import { DesktopLayout } from '@/components/desktop/DesktopLayout';
import { SuccessMessage } from '@/components/desktop/auth/signup/SuccessMessage';
import { EmailVerificationGuide } from '@/components/desktop/auth/signup/EmailVerificationGuide';

export function DesktopSignupSuccessPage() {
  return (
    <DesktopLayout>
      <div className="min-h-[80vh] flex items-center justify-center py-12">
        <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg border border-gray-200 px-12 py-16">
          {/* Success Message Section */}
          <SuccessMessage className="mb-12" />
          
          {/* Help Guide Section */}
          <EmailVerificationGuide />
        </div>
      </div>
    </DesktopLayout>
  );
}